<div class="footer">
    <div [translate]="'mobile.footer.title'"
         [translateParams]="{name: (configurationServer$ | async)?.serverName === serverNamesEnum.CCC ? '© ' + currentYear + ' Cold Chain Cloud' : '© ' + currentYear + ' SensorsCloud'}"
    ></div>
</div>
